export const types = {
    routerlink: "routerlink",
    hyperlink: "hyperlink"
};